import {STRING as ORIG_STRING} from "@infonova/framework/lib/webcomponents/util/STRING";
import {AttributeType} from "@infonova/framework/lib/webcomponents/ReactWebComponentDescription";

const ANGULAR_JS_VALIDATOR = (input?: unknown) => {
    return typeof input != "string" || !input.startsWith("{{");
}

/**
 * Web component STRING type which adds a validation for AngularJS '{{'. (AngularJS creates the dom
 * with placeholder not replaced - this could lead to problems. To circumvent this a string containing
 * '{{' is considered to be invalid => the component is not rendered)
 * @param name
 * @constructor
 */
export function STRING<T>(name: keyof T): AttributeType<T> {
    const type = ORIG_STRING(name);
    if (typeof type === 'object') {
        type.validator = ANGULAR_JS_VALIDATOR;
    }
    return type;
}
